// extracted by mini-css-extract-plugin
export default {"table":"region-feedbacks_table__9Hkw+","name":"region-feedbacks_name__OpbHi","new":"region-feedbacks_new__Z2+kW"};